import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count", "total", "submitBtn", "selectAllCheckbox", "tableBody", "row"]
  static values = { price: Number }

  connect() {
    this.updateCount()
  }

  updateCount() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const count = checked.length
    const total = (count * this.priceValue / 100).toFixed(2)

    this.countTarget.textContent = count
    this.totalTarget.textContent = total

    // Enable/disable submit button
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = count === 0
      if (count === 0) {
        this.submitBtnTarget.classList.add('opacity-50', 'cursor-not-allowed')
      } else {
        this.submitBtnTarget.classList.remove('opacity-50', 'cursor-not-allowed')
      }
    }

    // Update select all checkbox state
    if (this.hasSelectAllCheckboxTarget) {
      const enabledCheckboxes = this.checkboxTargets.filter(cb => !cb.disabled)
      if (enabledCheckboxes.length === 0) {
        this.selectAllCheckboxTarget.checked = false
        this.selectAllCheckboxTarget.indeterminate = false
      } else if (checked.length === 0) {
        this.selectAllCheckboxTarget.checked = false
        this.selectAllCheckboxTarget.indeterminate = false
      } else if (checked.length === enabledCheckboxes.length) {
        this.selectAllCheckboxTarget.checked = true
        this.selectAllCheckboxTarget.indeterminate = false
      } else {
        this.selectAllCheckboxTarget.checked = false
        this.selectAllCheckboxTarget.indeterminate = true
      }
    }
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(cb => {
      if (!cb.disabled) {
        cb.checked = checked
      }
    })
    this.updateCount()
  }

  selectAll() {
    this.checkboxTargets.forEach(cb => {
      if (!cb.disabled) {
        cb.checked = true
      }
    })
    this.updateCount()
  }

  deselectAll() {
    this.checkboxTargets.forEach(cb => {
      cb.checked = false
    })
    this.updateCount()
  }

  filterByAddress(event) {
    const onlyWithAddress = event.target.checked

    this.rowTargets.forEach(row => {
      const hasAddress = row.dataset.hasAddress === "true"
      if (onlyWithAddress && !hasAddress) {
        row.classList.add('hidden')
      } else {
        row.classList.remove('hidden')
      }
    })
  }
}
